import './App.css';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Login from "./shared/authentication/login";
import { getAccessToken } from "./shared/authentication/authentication";
import ForgotPassword from "./shared/authentication/forgot-password";
import Reset from "./shared/authentication/reset";
import SignUp from "./shared/authentication/sign-up";
import MainLayout from "./layouts/main-layout";
import 'rsuite/dist/styles/rsuite-default.css';
import 'c3/c3.css';
import Loader from "./shared/authentication/loader";
import axios from 'axios';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Loader />
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/reset" component={Reset} />
          <Route path="/sign-up" component={SignUp} />
          {/*<Route path="/modal" component={SaModal}/>*/}
          <PrivateRoute path="/*" component={MainLayout} />
        </Switch>
        <ToastContainer position={"bottom-right"} />
      </div>
    </Router>
  );
}

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getAccessToken() ?
        <Component {...props} />
        :
        (
          <Redirect
            to={{
              pathname: "/login"
            }}
          />
        )
    }
  />

);

axios.interceptors.request.use(
  async config => {
    if (process.env.REACT_APP_HOST.charAt(process.env.REACT_APP_HOST.length - 1) === "/" && config.url.charAt(process.env.REACT_APP_HOST.length) === "/") {
      config.url = config.url.slice(0, process.env.REACT_APP_HOST.length - 1) + config.url.slice(process.env.REACT_APP_HOST.length);
    }

    let accessToken = getAccessToken();
    let serverCallUrl = new URL(config.url);

    if (serverCallUrl.pathname.includes("/auth")) return config;

    if (accessToken) {
      config.headers["authorization"] = `Bearer ${accessToken}`;
      config.headers["cache-control"] = `no-cache`;
    }

    return config;
    // or throw new Error('User required')
  },
  // I don't think this function is required
  function (error) {
    console.log("Axios interceptor error");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  async (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config
    const serverCallUrl = new URL(originalRequest.url)
    const status = error.response.status

    if (
      (status === 401) &&
      !originalRequest._retry &&
      !serverCallUrl.pathname.includes('/auth')
    ) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }

    return Promise.reject(error)
  })

export default App;
